export default function getOrderBy(
  field: string,
  direction: "asc" | "desc" | "ASC" | "DESC"
) {
  return field + "_" + direction.toUpperCase();
}
